import api from './index'

export default {
  list(params) {
    return api.get('/admin/submissions', { params })
  },
  getById(id) {
    return api.get(`/admin/submissions/${id}`)
  },
  updateStatus(id, data) {
    return api.patch(`/admin/submissions/${id}`, data)
  }
}
